import actions from './actions';

const { changeLayoutMode, changeRtlMode, setMobile, setLocale, setVersion, setMemberArea, setMultiPlatform } = actions;

export { changeLayoutMode, changeRtlMode, setMobile, setLocale, setVersion, setMemberArea, setMultiPlatform };
